module.exports = __webpack_public_path__ + "static/media/banner7.3cc209cb.jpg";